<div class='page traveler'>
  <div class="row justify-center center form-dialog" style="padding:0 4%;">
    <pivot-tile-form [(config)]="pivot_config" style="width:60%;"></pivot-tile-form>
  </div>
  <div>
    <pivot-tile [showUI]="true" [config]="pivot_config"></pivot-tile>
  </div>
</div>
